<template>
  <div class="c-list grid grid-cols-1" :style="styleList">
    <template v-for="{item, list, space, subtitle, value} in propList" :key="value">
      <div v-if="subtitle" class="ltr:pl-2 rtl:pr-2 pb-1 font-caption text-basic-subtitle uppercase" v-html="subtitle"/>
      <div v-else-if="space" class="h-8"/>
      <template v-else-if="list">
        <d-motion-transform :open="list.open" adaptive="section">
          <template v-slot:head>
            <c-item
              v-bind="item"
              :focus="list.open"
              :turn="list.open"
              class="window-static"
              icon-trailing="arrow-bottom"
              @click="list.on"
            />
          </template>
          <template v-slot:body>
            <c-list v-bind="list" :selected="selected" @on-click="onClick" class="py-1"/>
          </template>
        </d-motion-transform>
      </template>
      <c-item v-else v-bind="item" @on-click="onClick"/>
    </template>
  </div>
</template>

<script>
import CItem from '@/components/CItem'
import DMotionTransform from 'dcode/components/DMotionTransform'
import { props } from './props'
import { computed } from 'vue'
import useItems from './useItems'

export default {
  name: 'CList',
  components: {
    CItem,
    DMotionTransform
  },
  props,
  emits: ['on-click', 'on-group'],
  setup (props, context) {
    const propList = useItems(props, context)

    const styleList = computed(() => {
      return { '--_it-margin': props.marginItem }
    })

    const onClick = event => context.emit('on-click', event)

    return {
      propList,
      styleList,
      onClick
    }
  }
}
</script>

<style lang="scss">
.c-list {
  gap: var(--_it-margin, 0);
}
</style>
